<template>
  <div class="user-info-setting-form">
    <template v-if="displayFormData.length">
      <el-card
        v-for="(item, index) in displayFormData"
        :key="item.id"
        class="box-card card-container"
        :body-style="{'padding': '16px'}"
      >
        <!-- Title -->
        <div slot="header" class="sub-title">
          <span class="title-hint">|</span>
          <span>排序{{ index + 1 }}</span>
          <img
            v-if="showControl.showDeleteBtn"
            class="button--delete"
            src="@/assets/setting/delete.svg"
            alt="Delete icon"
            @click="deleteItem(item.id)"
          >
        </div>

        <BaseElForm
          ref="rulesForm"
          class="card__form"
          label-position="top"
          :model="displayFormData[index]"
          :rules="rules"
        >
          <BaseElFormItem class="card__form__item" label="欄位名稱" prop="name">
            <BaseElInput v-model="item.name" :disabled="disabledControl.nameField" />
          </BaseElFormItem>
          <BaseElFormItem class="card__form__item" label="Key" prop="key">
            <label slot="label">
              <span class="font-medium">Key</span>
              <span v-if="showControl.isCustomMode" class="enum__tip">(系統用代碼，僅能輸入英文與數字，最多15字)</span>
            </label>
            <BaseElInput
              v-model="item.key"
              :disabled="disabledControl.keyField(item)"
            />
          </BaseElFormItem>
          <BaseElFormItem class="card__form__item" label="欄位備註">
            <BaseElInput v-model="item.prompt" />
          </BaseElFormItem>
          <BaseElFormItem class="card__form__item" label="欄位種類" prop="type">
            <BaseElInput v-if="showControl.showTypeAsInput()" v-model="item.type" :disabled="disabledControl.typeField" />
            <BaseElSelect
              v-else-if="showControl.showTypeAsSelect()"
              v-model="item.type"
              name="type"
            >
              <BaseElSelectOption
                v-for="subItem in typeOption"
                :key="subItem.value"
                :label="subItem.label"
                :value="subItem.value"
              />
            </BaseElSelect>
          </BaseElFormItem>
          <BaseElFormItem
            v-if="showControl.showEnumField(item.type)"
            class="card__form__item"
            label="欄位選項"
            prop="enum"
          >
            <label slot="label">
              <span class="font-medium">欄位選項</span>
              <!-- <span class="enum__tip">(至少兩項，最多二十項)</span> -->
            </label>
            <BaseElSelect
              v-model="item.enum"
              style="height: 100%"
              multiple
              filterable
              allow-create
              @change="updateEnum(item.key, item.enum)"
            >
              <BaseElSelectOption
                v-for="subItem in item.enum"
                :key="subItem"
                :label="subItem"
                :value="subItem"
              />
            </BaseElSelect>
          </BaseElFormItem>
          <BaseElFormItem
            v-if="showControl.showSubFieldOptions(item.type)"
            class="card__form__item"
            label="欄位選項"
            prop="subFieldOptions"
          >
            <label slot="label">
              <span class="font-medium">欄位選項</span>
            </label>
            <BaseElButton
              plain
              @click="openEditFieldOptionsModal(item)"
            >
              編輯欄位選項
            </BaseElButton>
            <!-- <div
              v-if="item.subFieldOptions && item.subFieldOptions.length > 0"
              class="mt-2 text-sm text-gray-600"
            >
              已設定 {{ getTotalSubOptions(item.subFieldOptions) }} 個子選項
            </div> -->
            <!-- <div
              v-if="showSubFieldValidationError(item)"
              class="mt-1 text-xs text-red-500"
            >
              您尚未設定，選項至少 2 項，最多 1000 項
            </div> -->
          </BaseElFormItem>
          <BaseElFormItem class="card__form__item" label="欄位必填/選填" prop="required">
            <BaseElSelect
              v-model="item.required"
              :disabled="disabledControl.requiredField(item.key)"
            >
              <BaseElSelectOption
                v-for="subItem in requiredOptions"
                :key="subItem.value"
                :label="subItem.label"
                :value="subItem.value"
              />
            </BaseElSelect>
          </BaseElFormItem>
          <BaseElFormItem class="card__form__item" label="顯示於註冊過程" prop="display">
            <BaseElSwitch
              v-model="item.display"
              inactive-text="關閉"
              active-text="開啟"
              :disabled="disabledControl.displayField(item.key)"
            />
          </BaseElFormItem>
          <BaseElFormItem class="card__form__item" label="開放後台編輯" prop="adminEdit">
            <BaseElSwitch
              v-model="item.adminEdit"
              inactive-text="關閉"
              active-text="開啟"
            />
          </BaseElFormItem>
          <BaseElFormItem class="card__form__item" label="會員卡資料設定" prop="adminEdit">
            <BaseElSelect
              :value="observeMemberOption(item)"
              @change="observeMemberOption = { index: index, value: $event }"
            >
              <BaseElSelectOption
                v-for="subItem in memberCenterOptions"
                :key="subItem.value"
                :label="subItem.label"
                :value="subItem.value"
              />
            </BaseElSelect>
          </BaseElFormItem>
          <BaseElFormItem v-if="showControl.showAutoTag(item)" class="card__form__item" label="會員標籤" prop="autoTag">
            <BaseElSwitch
              v-model="item.autoTag"
              inactive-text="關閉"
              active-text="開啟"
            />
          </BaseElFormItem>
        </BaseElForm>
      </el-card>
    </template>
    <el-row
      v-if="showControl.canAddNewField"
      type="flex"
      justify="center"
    >
      <BaseElButton class="button--add" @click="addItem">新增 +</BaseElButton>
    </el-row>

    <PageFixedFooter
      @cancel="$emit('close-user-info-setting')"
      @confirm="submitSetting"
    />

    <!-- 編輯欄位選項模態框 -->
    <EditFieldOptionsModal
      v-if="editFieldOptionsModal.visible"
      :value="editFieldOptionsModal.subFieldOptions"
      @close="closeEditFieldOptionsModal"
      @confirm="updateSubFieldOptions"
    />
  </div>
</template>

<script>
import formUtils from '@/utils/form'
import EditFieldOptionsModal from '@/views/Basic/OAuthSetting/components/EditFieldOptionsModal.vue'

export default {
  name: 'UserInfoSettingForm',
  components: {
    EditFieldOptionsModal,
  },
  props: {
    activeType: { type: String, required: true, default: 'base' },
    formData: { type: Array, required: true, default: () => [] },
  },
  setup () {
    // 產生不超過15字元的 key
    function generateDefaultKey (name = '') {
      const base = name
        ? name.replace(/[^a-zA-Z0-9]/g, '').toLowerCase()
        : 'field'
      const baseShort = base.slice(0, 10)
      const maxRandomLen = 15 - baseShort.length
      const randomStr = Math.random().toString(36).substr(2, Math.max(3, Math.min(5, maxRandomLen)))
      return (baseShort + randomStr).slice(0, 15)
    }
    return {
      generateDefaultKey,
    }
  },
  data () {
    return {
      requiredOptions: [
        {
          label: '必填',
          value: true,
        },
        {
          label: '選填',
          value: false,
        },
      ],
      memberCenterOptions: [
        {
          label: '僅顯示於會員卡',
          value: 'only-show',
          show: true,
          edit: false,
        },
        {
          label: '會員卡檢視與編輯',
          value: 'show-edit',
          show: true,
          edit: true,
        },
        {
          label: '不顯示於會員卡',
          value: 'no-show',
          show: false,
          edit: false,
        },
      ],
      typeOption: [
        {
          label: '簡答',
          value: 'text',
        },
        {
          label: '詳答',
          value: 'richtext',
        },
        {
          label: '單選',
          value: 'radio',
        },
        {
          label: '多選',
          value: 'checkbox',
        },
        {
          label: '單選 - 包含子欄位',
          value: 'radioSubField',
        },
        {
          label: '多選 - 包含子欄位',
          value: 'checkboxSubField',
        },
        {
          label: '上傳圖片',
          value: 'restrictedImage',
        },
      ],
      formDataBase: this.convertToDisplayFormData('base'),
      formDataCustom: this.convertToDisplayFormData('customized'),
      editFieldOptionsModal: {
        visible: false,
        currentItem: null,
        subFieldOptions: [],
      },
      rules: {
        name: [
          { required: true, message: '請輸入欄位名稱', trigger: 'blur' },
        ],
        key: [
          { required: true, message: '請輸入 Key', trigger: 'blur' },
          {
            validator: (_, value, callback) => {
              if (value === 'taxId') callback()
              const regexp = /^[a-zA-Z0-9]{1,15}$/
              if (!regexp.test(value)) callback(new Error('僅能輸入英文或數字，最多15字'))
              else callback()
            },
            trigger: 'blur',
          },
        ],
        type: [
          { required: true, message: '請輸入欄位種類', trigger: 'change' },
        ],
        enum: [
          { required: true, message: '請選擇欄位選項', trigger: 'change' },
          {
            validator: (_, value, callback) => {
              if (value.length < 2) {
                callback(new Error('請至少選擇兩項'))
              } else if (value.length > 1000) {
                callback(new Error('選項數量不能超過 1000 項'))
              } else {
                callback()
              }
            },
            trigger: 'change',
          },
        ],
        subFieldOptions: [
          {
            validator: (_, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error('您尚未設定，選項至少 2 項，最多 1000 項'))
              } else {
                const totalOptions = value.reduce((total, group) => total + (group.childOptions?.length || 0), 0)
                if (totalOptions < 2) {
                  callback(new Error('您尚未設定，選項至少 2 項，最多 1000 項'))
                } else if (totalOptions > 1000) {
                  callback(new Error('子選項總數不能超過 1000 項'))
                } else {
                  callback()
                }
              }
            },
            trigger: 'change',
          },
        ],
        required: [
          { required: true, message: '請選擇欄位必填/選填', trigger: 'change' },
        ],
      },
    }
  },

  computed: {
    showControl () {
      const controls = {
        // 基本顯示控制
        isBaseMode: this.activeType === 'base',
        isCustomMode: this.activeType === 'customized',
        canAddNewField: this.activeType !== 'base' && this.formDataCustom.length < 20,

        // 欄位類型顯示控制
        showTypeAsInput: () => this.activeType === 'base',
        showTypeAsSelect: () => this.activeType !== 'base',

        // 欄位選項顯示控制
        showEnumField: (fieldType) => this.activeType !== 'base' && ['radio', 'checkbox'].includes(fieldType),
        showSubFieldOptions: (fieldType) => this.activeType !== 'base' && ['radioSubField', 'checkboxSubField'].includes(fieldType),

        // 會員標籤顯示控制
        showAutoTag: (item) => this.activeType === 'customized' && ['radio', 'checkbox', 'radioSubField', 'checkboxSubField'].includes(item.type),

        // 刪除按鈕顯示控制
        showDeleteBtn: this.activeType !== 'base',
      }

      return controls
    },

    disabledControl () {
      const controls = {
        // 欄位名稱停用控制
        nameField: this.activeType === 'base',

        // Key 欄位停用控制
        keyField: (item) => this.activeType === 'base' || !item.newField,

        // 欄位種類停用控制
        typeField: this.activeType === 'base',

        // 必填/選填停用控制
        requiredField: (key) => ['name'].includes(key),

        // 顯示於註冊過程停用控制
        displayField: (key) => ['name'].includes(key),
      }

      return controls
    },

    displayFormData () {
      return this.activeType === 'base' ? this.formDataBase : this.formDataCustom
    },
    observeMemberOption: {
      get () {
        const defaultOption = this.memberCenterOptions[1]
        return (field) => {
          const { memberShow = true, memberEdit = true } = field
          const option = this.memberCenterOptions.find(opt => opt.show === memberShow && opt.edit === memberEdit) || defaultOption
          return option.value
        }
      },
      set ({ index, value }) {
        const { show, edit } = this.memberCenterOptions.find(opt => opt.value === value) || { show: false, edit: false }
        const currentFormData = this.showControl.isBaseMode ? this.formDataBase : this.formDataCustom
        const currentField = currentFormData[index]
        currentFormData.splice(index, 1, { ...currentField, memberShow: show, memberEdit: edit })
      },
    },
  },

  methods: {
    convertToDisplayFormData (type) {
      const sortList = ['name', 'birthday', 'gender', 'email', 'address']
      const tempFormData = this.formData
        .filter(item => type === 'base' ? item.isBase : !item.isBase)
        .map(item => {
          const result = { ...item, id: item.key }
          if (['radioSubField', 'checkboxSubField'].includes(item.type)) {
            result.subFieldOptions = Array.isArray(item.subFieldOptions) ? item.subFieldOptions : []
          } else {
            delete result.subFieldOptions
          }
          return result
        })

      tempFormData.sort((a, b) => {
        return sortList.indexOf(a.key) - sortList.indexOf(b.key)
      })

      return tempFormData
    },

    convertToSubmitFormData () {
      let tempFormData = {}
      if (this.showControl.isBaseMode) tempFormData = this.formDataBase
      if (this.showControl.isCustomMode) {
        tempFormData = this.formDataCustom
        tempFormData.forEach(item => {
          const type = item.type
          if (type === 'text') item.autoTag = false
          if (type === 'richtext') item.autoTag = false
          // 清理子欄位選項類型的 enum 欄位
          if (['radioSubField', 'checkboxSubField'].includes(type)) {
            delete item.enum
          }
        })
      }

      tempFormData = tempFormData.map(item => {
        const res = { ...item }
        delete res.id
        delete res.newField
        return res
      })

      const tempBase = this.formData.filter(item => item.isBase)
      const tempCustom = this.formData.filter(item => !item.isBase)

      return this.showControl.isBaseMode ? [...tempFormData, ...tempCustom] : [...tempBase, ...tempFormData]
    },
    async submitSetting () {
      let someFail = false
      for (let count = 0; count < this.displayFormData.length; count += 1) {
        const pass = await formUtils.checkForm(this.$refs.rulesForm[count])
        if (!pass) {
          someFail = true
        }
      }
      if (someFail) {
        this.$message.error('資料未填寫完整')
        return
      }

      const tempFormData = this.convertToSubmitFormData()

      this.$emit('submit-setting', tempFormData)
    },

    addItem () {
      // 產生預設 key
      const key = this.generateDefaultKey()
      const addItem = {
        id: Date.now(),
        name: '', // 欄位名稱
        key, // 系統代碼 (預設不超過15字元)
        type: '', // 欄位種類
        prompt: undefined, // 欄位備註
        isBase: false, // 是否為固定欄位
        display: true, // 顯示於註冊過程
        required: '', // 必填/選填
        adminEdit: true, // 後台是否能更改
        memberShow: true, // 會員卡檢視
        memberEdit: true, // 會員卡編輯
        newField: true, // 區隔新增自定義欄位
        autoTag: false,
      }
      this.formDataCustom.push(addItem)
    },

    deleteItem (deleteTargetId) {
      const deleteIndex = this.formDataCustom.findIndex(item => item.id === deleteTargetId)
      this.formDataCustom.splice(deleteIndex, 1)
    },

    updateEnum (targetKey, updatedEnum) {
      this.formDataCustom.forEach(item => {
        if (item.key === targetKey) item.enum = [...updatedEnum]
        // 若 type 不是 subField 類型，保證 subFieldOptions 不殘留
        if (!this.showControl.showSubFieldOptions(item.type)) {
          delete item.subFieldOptions
        }
      })
    },

    // 子欄位選項相關方法
    openEditFieldOptionsModal (item) {
      this.editFieldOptionsModal.currentItem = item
      if (this.showControl.showSubFieldOptions(item.type)) {
        if (!Array.isArray(item.subFieldOptions)) {
          this.$set(item, 'subFieldOptions', [])
        }
        this.editFieldOptionsModal.subFieldOptions = [...item.subFieldOptions]
      } else {
        this.editFieldOptionsModal.subFieldOptions = []
      }
      this.editFieldOptionsModal.visible = true
    },

    closeEditFieldOptionsModal () {
      this.editFieldOptionsModal.visible = false
      this.editFieldOptionsModal.currentItem = null
      this.editFieldOptionsModal.subFieldOptions = []
    },

    updateSubFieldOptions (subFieldOptions) {
      if (this.editFieldOptionsModal.currentItem) {
        if (this.showControl.showSubFieldOptions(this.editFieldOptionsModal.currentItem.type)) {
          this.editFieldOptionsModal.currentItem.subFieldOptions = [...subFieldOptions]
        } else {
          delete this.editFieldOptionsModal.currentItem.subFieldOptions
        }
      }
      this.resetAllValidate()
      this.closeEditFieldOptionsModal()
    },

    getTotalSubOptions (subFieldOptions) {
      if (!subFieldOptions) return 0
      return subFieldOptions.reduce((total, group) => total + (group.childOptions?.length || 0), 0)
    },

    showSubFieldValidationError (item) {
      if (!this.showControl.showSubFieldOptions(item.type)) return false
      if (!Array.isArray(item.subFieldOptions) || item.subFieldOptions.length === 0) return true
      const totalOptions = this.getTotalSubOptions(item.subFieldOptions)
      return totalOptions < 2 || totalOptions > 1000
    },

    resetAllValidate () {
      this.$refs.rulesForm.forEach(form => {
        formUtils.clearValidate(form)
      })
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-select .el-input {
  @apply h-full;
}
::v-deep .el-tag--info {
  @apply h-full break-all;
  white-space: break-spaces;
}
::v-deep .el-select__tags {
  @apply flex flex-wrap;
}

::v-deep .box-card {
  @apply relative;
  @apply mb-5;
  .el-card__header {
    @apply py-[9px] border-b-0;
  }
}

.card__form {
  @apply flex flex-wrap;
}

.card__form__item {
  flex: 0 0 50%;
  @apply mb-6;
}

.sub-title {
  @apply text-[24px] font-medium;
}

.title-hint {
  color: var(--primary-100);
  @apply mr-[5px] items-center;
}

.enum__tip {
  @apply text-sub text-gray-80 font-normal;
}
.button--delete {
  @apply absolute top-[23px] right-[25px];
  @apply w-[14px] h-[18px] cursor-pointer;
}

.button--add {
  @apply mt-3 w-1/2 h-[44px];
}
</style>
